module.exports = __webpack_public_path__ + "static/media/smhc-right-icon.24348d68.png";